<template>
  <div
    class="popup popup-privacy"
    :class="{ 'modal-in': isShow, 'modal-out': !isShow }"
    id="privacyPopup"
  >
    <div class="shorex-title-text">
      <div class="title-wrapper-box">
        <div>{{isRow == false ? '乘客票据合同及安全与保障政策':'票据合同及隐私政策'}}</div>
        <div class="contry-state" @click="getMessage">{{isRow == false ? '国外航线':'国内航线'}}&gt;</div>
      </div>
      
      <a class="shorexDetail-returnButton" @click="onGoBack()">
        <img
          src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightWhite.png"
        />
      </a>
    </div>
    <!-- :src="showRow == false ? iframeSrc : iframeSrcRow" -->
    <iframe class="iframe-box" v-show="isRow == false" :src="iframeSrc"></iframe>
    <iframe class="iframe-box" v-show="isRow == true" :src="iframeSrcRow"></iframe>
  </div>
</template>

<script>
export default {
  name: "GuestInfoPrivacyPopup",
  props: {
    isShow: {
      type: Boolean,
      default() {
        return false;
      },
    },
    onGoBack: {
      type: Function,
    },
    tab: {
      type: Number,
    },
    changeTab: {
      type: Function,
    },
    showRow:{
            type: Boolean,
            default () {
                return false
            }
        },
  },
  
  data() {
    return {
      currentTab: 0,
      iframeSrc: `${process.env.VUE_APP_PC_URL}/wz_index_contract/index`,
      // iframeSrcRow: `${process.env.VUE_APP_PC_URL}/wz_index_contract/indexRow`,
      iframeSrcRow: `${process.env.VUE_APP_PC_URL}/wz_index_contract/indexRow`,
      isRow: false
    };
  },
  methods: {
    onTabChange(tab) {
      this.currentTab = tab;
      this.changeTab(tab);
    },
    getMessage() { 
      this.isRow = !this.isRow;
    },
  },
  watch: {
    tab(newValue) {
      this.currentTab = newValue;
    },
    showRow:{
      handler(newValue) {
        console.log('zhixin',newValue);
        this.isRow = newValue;
      },
      immediate: true
    }
    
  },
};
</script>

<style lang="less" scoped>
#privacyPopup.popup {
  position: fixed;
  background-color: #f6f7f8;
  transform: translate3d(100%, 0, 0);
  display: block;
  z-index: 10401;
}
#privacyPopup.modal-in {
  position: fixed;
  background-color: #f6f7f8;
  transform: translate3d(0, 0, 0);
}
#privacyPopup.modal-out {
  transform: translate3d(100%, 0, 0);
}

#privacyPopup {
  .shorex-title-text {
    padding: 15px 20px 15px 40px !important;
    box-sizing: border-box !important;
    background-color: #000;
    overflow: hidden;
    text-align: center;
    margin-bottom: 10px;
    position: fixed;
    width: 100%;
    z-index: 99;
    .title-wrapper-box{
      display: flex;
      align-self: center;
      justify-content: space-between;
      font-family: PingFang-SC-Medium;
      font-size: 16px;
      color: #ffffff;
      line-height: 1;
      width: 100%;
      
    }
    .contry-state{
      color: #ffffff;
      cursor: pointer;
      font-size: 13px;
      line-height: 1;
    }
    .shorexDetail-returnButton {
      width: 30px;
      position: absolute;
      top: 13px;
      left: 20px;
      text-align: left;
      > img {
        width: 33%;
      }
    }
  }

  .popupover2-m {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -moz-box-orient: vertical;
    -moz-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    margin-top: 50px;
    .policyPopup-tab {
      -webkit-box-flex: 0;
      -webkit-flex: none;
      -moz-box-flex: 0;
      -ms-flex: none;
      flex: none;
      display: -webkit-box;
      display: -webkit-flex;
      display: -moz-box;
      display: -ms-flexbox;
      display: flex;
      background-color: #fff;
      -webkit-box-shadow: 0 2px 2px 0 #d6d7d8;
      box-shadow: 0 2px 2px 0 #d6d7d8;
      .policyPopup-tab-item {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        -moz-box-flex: 0;
        -ms-flex: none;
        flex: none;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -moz-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        width: 50%;
        height: 50px;
        text-align: center;
        p {
          display: inline-block;
          margin: 0;
          font-size: 14px;
          line-height: 46px;
          color: #666;
          border-top: 2px solid transparent;
          border-bottom: 2px solid transparent;
        }
      }
      .active p {
        color: #4a90e2;
        border-bottom: 2px solid #4a90e2;
      }
    }

    .policyPopup-m {
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      -moz-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      overflow-y: auto;
      background-color: #fff;
      .policyPopup-box {
        padding: 15px 20px 0;
        font-size: 11px;
        line-height: 20px;
        color: #666;
        .tc {
          text-align: center;
        }
      }
    }
  }

  .scrollArea{
    height: auto;
    overflow: scroll;
  }

  .leftPoint{
    padding-left: 20px;
  }
  .leftPoint li{
    list-style-type: circle;
  }
}

.iframe-box {
  width: 100vw;
  height: calc(100vh);
  border: none;
  padding: 0;
  margin: 0;
}
.iframe-box .content::-webkit-scrollbar {
  display: none !important;
}
.popup-privacy {
  overflow: hidden;
}
</style>

